import React from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';
import cx from 'classnames';

import DefaultQVContent from './components/DefaultQVContent';
import FinanceQVContent from './components/FinanceQVContent';

import { isFinanceQVSelector, isDefaultQVSelector } from '../selectors';

const AppQuickView = ({ onClose }) => {
  const isFinanceQV = useSelector(isFinanceQVSelector);
  const isDefaultQV = useSelector(isDefaultQVSelector);

  return (
    <div
      className={cx('app-quick-view', {
        'app-quick-view--default': isDefaultQV,
        'app-quick-view--finance': isFinanceQV,
      })}
    >
      {isDefaultQV && <DefaultQVContent onClose={onClose} />}
      {isFinanceQV && <FinanceQVContent onClose={onClose} />}
    </div>
  );
};

AppQuickView.propTypes = {
  onClose: T.func.isRequired,
};

export default AppQuickView;
